export default __webpack_public_path__ + "static/media/pinnacle_foundation_logo.21dedd5b.jpg";